import type { ReactNode } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useFela } from 'react-fela';

import { Heading, Text } from '@/modules/ui';

import { Modal, type ModalProps } from '../Modal';
import * as felaRules from './ConfirmationModal.rules';

export interface ConfirmationModalProps extends Omit<ModalProps, 'alignButtonRight' | 'extend'> {
    icon?: ReactNode;
    title?: ReactNode;
}

export function ConfirmationModal({ children = null, icon, title, ...props }: ConfirmationModalProps) {
    const { css } = useFela();

    return (
        <Modal
            extend={{
                container: felaRules.container,
            }}
            width={520}
            alignButtonsRight
            {...props}
        >
            {title && (
                <Heading elementType='h1' variant='h2' color='foregroundsPrimary' customStyle={felaRules.title}>
                    {title}
                </Heading>
            )}
            <Text customStyle={felaRules.text}>
                {icon === null ? null : (
                    <span className={css(felaRules.icon)}>{icon === undefined ? <ExclamationCircleFilled /> : icon}</span>
                )}
                {children}
            </Text>
        </Modal>
    );
}
